import React from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';

const HorizontalSlider = ({ children, scrollContainerClassName }) => {
  return <ScrollMenu scrollContainerClassName={scrollContainerClassName}>{children}</ScrollMenu>;
};

export default HorizontalSlider;
